/**
 * render/index.ts — backend factory. Default is the proven Canvas2D Scene.
 * `?gfx=webgpu` opts into the WebGPU backend *if* the browser supports it;
 * any init failure logs and falls back to Canvas2D so the page never breaks.
 */
import type { Renderer } from './types';
import { Scene } from './scene';

export async function createRenderer(canvas: HTMLCanvasElement): Promise<Renderer> {
    const want = new URLSearchParams(location.search).get('gfx');
    if (want === 'webgpu' && (navigator as unknown as { gpu?: unknown }).gpu) {
        try {
            const { WebGPURenderer } = await import('./webgpu');
            return await WebGPURenderer.create(canvas);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('[ppets] WebGPU unavailable — falling back to Canvas2D.', e);
        }
    }
    return new Scene(canvas);
}

export type { Renderer };
